import { json, type LoaderFunctionArgs } from '@remix-run/node';
import { getStatsNumbers } from '~/modules/error/api/get-stats-numbers.server';
import NotFoundPage from '@modules/error/page/NotFoundPage';
import React from 'react';
import { useCurrentCategory } from '@rocco/ui/website-header/hooks/use-current-category';

export const loader = async (args: LoaderFunctionArgs) => {
    const [statsNumbers] = await Promise.all([getStatsNumbers(args.context)]);

    return json(
        {
            statsNumbers,
            pageTheme: 'transparent',
        },
        {
            status: 404,
            statusText: 'Not found',
        }
    );
};

const NotFoundPageWithCategory = () => {
    const { setCategory } = useCurrentCategory();

    // Set the current category for header navigation
    React.useEffect(() => {
        setCategory(null);
    }, [setCategory]);

    return <NotFoundPage />;
};

export default NotFoundPageWithCategory;
